import { render, staticRenderFns } from "./StaffListView.vue?vue&type=template&id=486b0498&scoped=true"
import script from "./StaffListView.vue?vue&type=script&lang=js"
export * from "./StaffListView.vue?vue&type=script&lang=js"
import style0 from "./StaffListView.vue?vue&type=style&index=0&id=486b0498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b0498",
  null
  
)

export default component.exports